export const CJW_DI_STATUS_OPTIONS = Object.freeze([
  "Uploaded",
  "In progress",
  "Validated",
  "Validated with updates",
  "LC Estimated",
  "LC Processed",
  "DC Estimated",
  "DC Partially Processed",
  "DC Processed",
  "Excluded at LC",
  "Excluded at DC",
  "Rejected at LC",
  "Rejected at DC",
  "Paused at DC",
  "Flagged at DC",
  "Error",
  "Failed",
]);

const DELETABLE_STATUSES = new Set([
  "error",
  "failed",
  "on hold",
  "processed with errors",
  "validation failed",
]);

export const isCjwDiDeletableStatus = (status) =>
  DELETABLE_STATUSES.has(status?.trim().toLowerCase());

export const getCjwDiCostFileTooltip = (availability, action = "Download cost file") => {
  if (availability?.available) {
    return action;
  }

  switch (availability?.reason) {
    case "PENDING_LANDED_COST":
      return "Cost file will be available after landed-cost processing";
    case "PENDING_DC_APPROVAL":
      return "Cost file will be available after at least one DC-cost approval";
    case "UNAVAILABLE":
      return "Cost-file availability could not be loaded";
    default:
      return "Checking cost-file availability";
  }
};
